import { SECTORS } from "@/lib/content";

export default function Marquee() {
  const items = [...SECTORS, ...SECTORS];
  return (
    <div className="relative overflow-hidden bg-teal py-5" aria-hidden="true">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {items.map((s, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="px-8 font-display text-sm sm:text-base font-semibold uppercase tracking-[0.2em] text-white/85 whitespace-nowrap">{s}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-white/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
